import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/pavel_article.jpeg";

function IntervjuPavel() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.interviewPavel.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.interviewPavel.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/intervju-pavel-pajer"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.interviewPavel.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.interviewPavel.sections.intro")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.interviewPavel.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5">
          <img
            src={article_img}
            className="w-full"
            alt={i18next.t("pages.articles.list.interviewPavel.imageAlt")}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.intro2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.intro3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.customerClose.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.customerClose.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.customerClose.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.customerClose.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.motivation.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.motivation.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.motivation.content2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.simplify.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.simplify.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.simplify.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.simplify.content3")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.results.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.results.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.results.content2")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.accessibility.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.accessibility.content")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.accessibility.content2")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.accessibility.content3")}</p>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.accessibility.content4")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.team.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.team.content")}</p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewPavel.sections.music.title")}
            </h2>
            <p className="mb-2">{i18next.t("pages.articles.list.interviewPavel.sections.music.content")}</p>

            <p className="mt-6 font-bold">
              {i18next.t("pages.articles.list.interviewPavel.sections.closing")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntervjuPavel;


